// Define types for the Redux state
import { TemplateVM, ResponsesVM, GroupedItemsVM, GlobalResponsesVM, RuleSetsVM, InfoVM, ImageMarkersVM, TemplateHistoryItemStore, Template } from "@cmodules/checklist/assets/data/types"

class TemplateStore {
  past: TemplateHistoryItemStore[];
  response_sets: ResponsesVM;
  grouped_items: GroupedItemsVM;
  global_responses: GlobalResponsesVM;
  rule_sets: RuleSetsVM;
  relations: {
    /** Outside: means that the key1 item_id exists in key2 item_id (in key2 item_id rule or calculation or document_id)
     *  Means when the relation is outside, key1 will be before the key2
     *  The only case for outside and rule_set_behaviour is inside will mean key1 is after key2, but it exists in set next item action
     * */
    outside?: {
      [key1: string]: {
        [key2: string]: {
          uuid: string; /** Same as key2 item_id */
          calculation?: boolean;
          document_id?: boolean;
          rule_set_id?: boolean;
          rule_set_behaviour?: 'inside' | 'outside' | 'inside_outside'
        }
      }
    },
    inside?: {
      [key1: string]: {
        [key2: string]: {
          uuid: string; /** Same as key2 item_id */
          calculation?: boolean;
          document_id?: boolean;
          rule_set_id?: boolean;
          rule_set_behaviour?: 'inside' | 'outside' | 'inside_outside'
        }
      }
    }
  };
  info: InfoVM;
  image_markers: ImageMarkersVM;
  present: TemplateHistoryItemStore;
  future: TemplateHistoryItemStore[];
  global_items: Record<string, TemplateStore>;
  nested_templates: Template[];
  translations: string[];

  constructor(templateStore: Partial<TemplateStore> = {}) {
    // past: TemplateHistoryItemStore[] = [],
    //   response_sets: ResponsesVM = {},
    //   grouped_items: GroupedItemsVM = {},
    //   global_responses: GlobalResponsesVM = {},
    //   rule_sets: RuleSetsVM = {},
    //   relations: Record<string, any> = {},
    //   info: InfoVM = {} as InfoVM,
    //   image_markers: ImageMarkersVM = {},
    //   present: TemplateHistoryItemStore = new TemplateHistoryItemStore(),
    //   future: TemplateHistoryItemStore[] = [],
    //   global_items: Record<string, TemplateVM> = {}

    this.past = templateStore?.past ?? []
    this.response_sets = templateStore?.response_sets ?? {}
    this.grouped_items = templateStore?.grouped_items ?? {}
    this.global_responses = templateStore?.global_responses ?? {}
    this.rule_sets = templateStore?.rule_sets ?? {}
    this.relations = templateStore?.relations ?? {}
    this.info = templateStore?.info ?? {}
    this.image_markers = templateStore?.image_markers ?? {}
    this.present = new TemplateHistoryItemStore(templateStore?.present)
    this.future = templateStore?.future ?? []
    this.global_items = templateStore?.global_items ?? {}
    this.nested_templates = templateStore?.nested_templates ?? []
    this.translations = templateStore?.translations ?? []
  }
}
export { TemplateStore }
